export default __webpack_public_path__ + "static/media/Roboto-Medium.c90d94fb.woff2";